import SaveSolicitudesEventoCanje from "../../shared/saveSolicitudesEventoCanje/SaveSolicitudesEventoCanje";

const CreateSolicitudesEventoCanje = ()=>{
  return(
    <SaveSolicitudesEventoCanje title="Crear Solicitud de Evento/Canje "/>
  )
}
export default CreateSolicitudesEventoCanje;